import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { useErrorToast } from "~/hooks/use-error-toast";
import { Modal } from "~/components/modal/modal";
import { useKeywordGeneration } from "~/components/keywords-tab/hooks/use-keyword-generation";

export const RegenerateKeywordsDialog = ({
  onOpenChange,
  isOpen,
}: {
  onOpenChange: (open: boolean) => void;
  isOpen: boolean;
}) => {
  const { t } = useTranslation(["general", "productDetails"]);
  const { generateKeywords, errorUpdate } = useKeywordGeneration();

  const errorMessage = useMemo(() => {
    if (errorUpdate) {
      return t("productDetails:generatedKeywords.errorToast.errorUpdate");
    }
    return null;
  }, [errorUpdate, t]);

  useErrorToast(errorMessage);
  const handleRegenerateAllKeywordsModal = () => {
    generateKeywords({ regenerate: true });
    onOpenChange(false);
  };

  return (
    <Modal
      id="regenerate-keywords"
      open={isOpen}
      variant="warning"
      title={t("productDetails:generatedKeywords.refreshKeywordsModal.header")}
      description={t(
        "productDetails:generatedKeywords.refreshKeywordsModal.message",
      )}
      confirmLabel={t(
        "productDetails:generatedKeywords.refreshKeywordsModal.confirm",
      )}
      confirmIconName="sparkles"
      cancelLabel={t("general:buttons.cancel")}
      onOpenChange={onOpenChange}
      onConfirm={handleRegenerateAllKeywordsModal}
      aria-describedby={t(
        "productDetails:generatedKeywords.refreshKeywordsModal.header",
      )}
    />
  );
};
